<template>
    <div>
        <div class="container-fluid">   
            <div>
                <div id="mapping-app">   
                    <div id="mappingSystem">
                        <div  id="dmap">
                            <section id="displayMap" style="width:100%; height:100%;">
                                <div id="map-canvas" style="height:600px !important; clear:both;"></div>
                            </section>
                        </div>
                    </div><!--Mapping System-->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import whiteTheme from '../../lib/map-themes/white';
import mapping from '../../lib/map';
import violetTheme from '../../lib/violet';
import svg from '../../lib/svg';

export default {
  name: 'LocalCommunityMap',
  data() {
    return {
      title: "Mapping System",
      kml : "",
      zipcode:null,
      map:null,
      markers:null,
      loader:true,
      filters:{
        region: null,
        state: null,
        jurisdiction: null,
        megamarket: null,
        zipcode: null,
        zone: null
      },
      reset:false,
    }
  },
  mounted(){
    this.loader = false; 
    this.initialize();
  },
methods:{
    resetMap() {
        this.filters.region = null;
        this.filters.state = null;
        this.filters.jurisdiction = null;
        this.filters.megamarket = null;
        this.filters.zipcode = null;
        this.filters.zone = null;
        this.initialize();
    },
    initialize(){
         this.map = new google.maps.Map(document.getElementById('map-canvas'), {
              zoom: 5,
              center: new google.maps.LatLng(37.0902, -95.7129),
              mapTypeId: 'roadmap',
              styles: whiteTheme.style
        });
    
        axios.get( zurl + 'api/mapping/heatmaps/region/?format=json').then(response => {
            let res = response.data;
            for (var i = 0; i < res.length; i++){    
                this.getRegionKml(res[i]);   
            }
        }); 
    },
    getRegionKml(kmlLink){
    
       let kml = new google.maps.KmlLayer(zurl + kmlLink.kml, {
            suppressInfoWindows: true,
            preserveViewport: true,
            map: this.map,
        });
        
        
        this.map.data.addListener(kml,"mouseover",(kmlEvent) => {
              console.log(kmlEvent);
              document.getElementById('info-box').textContent =
              kmlEvent.feature.getProperty('letter'); 
        });
        
        //KML TRIGGER CLICK EVENT
        google.maps.event.addListener(kml, 'click', (kmlEvent) => {
            
            this.filters.region = kmlLink.region;
            console.log("Region Clicked", this.filters.region);
        
            this.map = new google.maps.Map(document.getElementById('map-canvas'), {
                zoom: kmlLink.zoom,
                center: new google.maps.LatLng(kmlLink.lat, kmlLink.lng),
                mapTypeId: 'roadmap',
              styles: whiteTheme.style
            });

            //http://127.0.0.1:8000/api/mapping/heatmaps/state/?region=ATL
            axios.get( zurl + 'api/mapping/heatmaps/state/?format=json&region=' + this.filters.region).then(response => {
                let res = response.data;
                for (var i = 0; i < res.length; i++){
                    this.getStatesKml(res[i]);
                }
            });

        });
    },
    getStatesKml(data){
        
        let kml = new google.maps.KmlLayer(zurl + data.kml, {
            suppressInfoWindows: true,
            preserveViewport: true,
            map: this.map,
        });
        
        //KML TRIGGER CLICK EVENT
        google.maps.event.addListener(kml, 'click', (kmlEvent) => {
            
            this.filters.state = data.state;
            console.log("State Clicked", this.filters.state);

            this.map = new google.maps.Map(document.getElementById('map-canvas'), {
                zoom: data.zoom,
                center: new google.maps.LatLng(data.lat, data.lng),
                mapTypeId: 'roadmap',
                styles: whiteTheme.style
            });

            //http://127.0.0.1:8000/api/mapping/heatmaps/jurisdiction/?state=FL
            axios.get( zurl + 'api/mapping/heatmaps/jurisdiction/?format=json&state=' + this.filters.state).then(response => {
                let res = response.data.results;
                
                for (var i = 0; i < res.length; i++){
                    this.getJurisdictionKml(res[i]);
                }
                
            });
        });
    },
    getJurisdictionKml(data){
        
        let kml = new google.maps.KmlLayer(zurl + data.kml, {
            suppressInfoWindows: true,
            preserveViewport: true,
            map: this.map,
        });
        
        //KML TRIGGER CLICK EVENT
        google.maps.event.addListener(kml, 'click', (kmlEvent) => {
            
            this.filters.jurisdiction = data.name;
            
            console.log("Jurisdiction Clicked", this.filters.jurisdiction);
            
            this.map = new google.maps.Map(document.getElementById('map-canvas'), {
                zoom: data.zoom,
                center: new google.maps.LatLng(data.lat, data.lng),
                mapTypeId: 'roadmap',
              styles: whiteTheme.style
            });
            
            //http://159.65.182.47/api/mapping/heatmaps/megamarket/?format=json&state=WI&jurisdiction=CHI120
            axios.get( zurl + 'api/mapping/heatmaps/megamarket/?format=json&state=' + this.filters.state + '&jurisdiction='+this.filters.jurisdiction).then(response => {
                let res = response.data.results;
                for (var i = 0; i < res.length; i++){
                  
                   this.getMegamarketKml(res[i]);
                }
            }).catch(function (error) {
                console.log(error);
            });
        });
    },
    getMegamarketKml(data){
        
        let kml = new google.maps.KmlLayer(zurl + data.kml, {
            suppressInfoWindows: true,
            preserveViewport: true,
            map: this.map,
        });
        
        //KML TRIGGER CLICK EVENT
        google.maps.event.addListener(kml, 'click', (kmlEvent) => {
            
            this.filters.megamarket = data.name;
            console.log("Megamarket Clicked", this.filters.megamarket);
            
            this.map = new google.maps.Map(document.getElementById('map-canvas'), {
                zoom: data.zoom,
                center: new google.maps.LatLng(data.lat, data.lng),
                mapTypeId: 'terrain',
                styles: mapping.style
            });
        
            console.log( zurl + 'api/mapping/heatmaps/zipcode/?format=json&jurisdiction='+this.filters.jurisdiction+'&megamarket=' + this.filters.megamarket);
            axios.get( zurl + 'api/mapping/heatmaps/zipcode/?format=json&jurisdiction='+this.filters.jurisdiction+'&megamarket=' + this.filters.megamarket).then(response => {
                let res = response.data.results;
                for (var i = 0; i < res.length; i++){
                   this.getZipcodeKml(res[i]);
                }
            });
        });
    },
    getZipcodeKml(data){
        
        let kml = new google.maps.KmlLayer(zurl + data.kml, {
            suppressInfoWindows: true,
            preserveViewport: true,
            map: this.map,
        });
        
        //KML TRIGGER CLICK EVENT
        google.maps.event.addListener(kml, 'click', (kmlEvent) => {
            
            this.filters.zipcode = data.name;
            console.log("Zipcode Clicked", this.filters.zipcode);
            
            this.map = new google.maps.Map(document.getElementById('map-canvas'), {
                zoom: data.zoom,
                center: new google.maps.LatLng(data.lat, data.lng),
                mapTypeId: 'roadmap',
                styles: whiteTheme.style
            });
            
            //http://127.0.0.1:8000/api/mapping/heatmaps/zipcode/?format=json&jurisdiction=CHI88&megamarket=1
            axios.get( zurl + 'api/mapping/heatmaps/zone/?format=json&jurisdiction='+this.jurisdiction+'&megamarket=' + this.filters.megamarket+'&zipcode=' + this.filters.zipcode).then(response => {
                let res = response.data.results;
                for (var i = 0; i < res.length; i++){
                   console.log("Zone, ",res[i]);
                }
            });
        });
    }
 }
}
</script>
<style lang="scss">

 #info-box {
        background-color: white;
        border: 1px solid black;
        bottom: 30px;
        height: 20px;
        padding: 10px;
        position: absolute;
        left: 30px;
}

#mapping-app {
    margin-top:10px;
}

.map-navigation {
    margin-top:10px;
}
</style>





// WEBPACK FOOTER //
// src/components/mapping/local-community.vue